import {
  Button,
  CopyIcon,
  FacebookIcon,
  Flex,
  Typography,
  XTwitterIcon,
  useToast,
} from '@iheartjane/reefer';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';

interface OpenWindowArgs {
  height: number;
  href: string;
  width: number;
}
const openWindow = ({ height, href, width }: OpenWindowArgs) => {
  const left =
    window.outerWidth / 2 +
    (window.screenX || window.screenLeft || 0) -
    width / 2;
  const top =
    window.outerHeight / 2 +
    (window.screenY || window.screenTop || 0) -
    height / 2;
  window.open(
    href,
    'sharer',
    `location=no,status=no,directories=no,centerscreen=yes,chrome=yes,menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`
  );
};

interface ShareProductProps {
  name: string;
}

export function ShareProduct({ name }: ShareProductProps) {
  const toast = useToast();
  const {
    appConfig: { facebookAppId },
  } = useRootLoaderData();

  const copyProductLink = async () => {
    await navigator.clipboard.writeText(location.href);

    toast.add({
      label: 'Link successfully copied.',
      time: 2500,
      variant: 'success',
    });
  };

  const shareFacebook = () => {
    openWindow({
      height: 436,
      href: `https://www.facebook.com/dialog/share?${new URLSearchParams({
        ...(facebookAppId && { app_id: facebookAppId }),
        display: 'popup',
        href: location.href,
      })}`,
      width: 626,
    });
  };

  const shareTwitter = () => {
    openWindow({
      height: 275,
      href: `https://twitter.com/intent/tweet?${new URLSearchParams({
        text: name,
        url: location.href,
      })}`,
      width: 626,
    });
  };

  return (
    <div>
      <Typography mb={8} mt={24} variant="body-bold" color="text-main">
        Share
      </Typography>

      <Flex flexDirection="row" gap={16}>
        {facebookAppId && (
          <Button.Icon
            ariaLabel="Share on Facebook"
            icon={<FacebookIcon />}
            onClick={shareFacebook}
            variant="tertiary"
          />
        )}
        <Button.Icon
          ariaLabel="Share on Twitter"
          icon={<XTwitterIcon />}
          onClick={shareTwitter}
          variant="tertiary"
        />
        <Button.Icon
          ariaLabel="Copy product link"
          icon={<CopyIcon />}
          onClick={copyProductLink}
          variant="tertiary"
        />
      </Flex>
    </div>
  );
}
